<template>
  <svg aria-hidden="true" width="32" height="32" viewBox="-2 -1 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" stroke="currentColor" />
    <path
      d="M10.3281 21.6367H11.9219V13.3633H12.0469L15.3516 21.6367H16.6484L19.9609 13.3633H20.0781V21.6367H21.6719V10.3633H19.6562L16.0625 19.3555H15.9375L12.3438 10.3633H10.3281V21.6367Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DayTokenM',
};
</script>
